import {usePostId} from '../../hook/useEditPost'
import PostEventsWidget from '../PostEventsWidget'
import PostRefererWidget from '../PostRefererWidget'
import {useStyles} from "./MetaBox.styles";

export default ()=>{
    const styles = useStyles();
    const postId = usePostId();
    return <div className={styles.root}>
        <div className={styles.events}>
            <h3>Events</h3>
            <PostEventsWidget postId={postId} />
        </div>
        <div className={styles.referer}>
            <h3>Top Referer</h3>
            <PostRefererWidget postId={postId} />
        </div>
    </div>
}